import styled from '@emotion/styled';

import { Div } from '../../../layouts';

export const getFadeTransitionDiv = (duration) =>
    styled(Div)`
        transition: opacity ${duration}ms ease-in-out;
        opacity: 0;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    `;
